export default function Rectangle({ children }) {
  return <div className="rectangle">{children}</div>;
}
